(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("europa", [], factory);
	else if(typeof exports === 'object')
		exports["europa"] = factory();
	else
		root["Europa"] = factory();
})(self, () => {
return 